import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
import Footer from "./components/Footer";
import App from './App';

ReactDOM.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLEID}>
      <App />
    </GoogleOAuthProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

